import {
  createContext,
  useContext,
  useLayoutEffect,
  useRef,
  useState,
} from "react";

export const PageTitleContext = createContext(null);

export function PageTitleProvider({ children }) {
  const [pageTitle, setPageTitle] = useState("");
  const pageTitleRef = useRef("");

  const updatePageTitle = (title) => {
    pageTitleRef.current = title;
    setPageTitle(title);
  };

  const getPageTitle = () => {
    return pageTitleRef.current;
  };

  return (
    <PageTitleContext.Provider
      value={{ pageTitle, updatePageTitle, getPageTitle }}
    >
      {children}
    </PageTitleContext.Provider>
  );
}

/**
 * Call this hook inside any screen to register a contextual page title that
 * will be captured by PrivateRoute when tracking navigation to RDS.
 *
 * @param {string} title  Human-readable label, e.g. "2026 Camry – Overview"
 *
 * The title is cleared back to "" when the component unmounts, so stale titles
 * from previous screens never bleed into the next navigation event.
 */
export function useSetPageTitle(title) {
  const ctx = useContext(PageTitleContext);

  useLayoutEffect(() => {
    if (!ctx || !title) {
      return;
    }

    ctx.updatePageTitle(title);

    return () => {
      ctx.updatePageTitle("");
    };
  }, [ctx, title]);
}
